<template>
  <div class="slcb-toddy__dialog" v-if="question.toddy">
    <figure class="slcb-toddy__dialog-icon float-left">
      <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
    </figure>
    <vue-typed-js :strings="question.strings" :typeSpeed="1" :showCursor="false" :contentType="'html'" @onComplete="getOnComplete()">
      <p class="typing slcb-toddy__dialog-text"></p>
    </vue-typed-js>
  </div>
</template>
<!-- 25 -->
<script>
import { VueTypedJs } from 'vue-typed-js'

export default {
  name: 'Question',
  props: ['question', 'replace'],
  components: {
    'vue-typed-js': VueTypedJs
  },
  watch: {
    'question.toddy': {
      handler (val) {
        if (this.replace !== undefined) {
          const substituirChave = (match, chave) => this.replace[chave] || match
          const regexChave = /%(\w+)%/g
          this.question.strings = this.question.strings.map((str) => str.replace(regexChave, substituirChave))
        }
      },
      deep: true
    }
  },
  methods: {
    getOnComplete: function () {
      return (this.question.input.show) ? this.showBoxInput() : this.nextStep()
    },
    showBoxInput: function () {
      this.$emit('showBoxInput', true)
    },
    nextStep: function () {
      this.$emit('nextStep', this.question)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Question.vue